import { AxiosResponse } from 'axios';
import { isString } from 'lodash';
import { publicInstance as axios } from '../../api/axios';

export type ResponseScan = {
  success: boolean;
  data: any;
};

export async function dataUrlToFile(dataUrl: string, type: string): Promise<File> {
  const myRequest = new Request(dataUrl);

  return fetch(myRequest)
    .then((response) => response.blob())
    .then((myBlob) => new File([myBlob], `${Date.now()}`, { type }));
}

export class DocumentService {
  public static async getDocumentScan(url: string) {
    try {
      const response: AxiosResponse<ResponseScan> = await axios.get(url);

      if (!response.data.success) {
        return Error('Сканер не підключено в порт USB');
      }

      if (isString(response.data.data))
        return await dataUrlToFile(`data:image/jpeg;charset=utf-8;base64,${response.data.data}`, 'image/jpeg');

      return await dataUrlToFile(`data:image/jpeg;charset=utf-8;base64,${response.data.data[0]}`, 'image/jpeg');
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Драйвер  ArmPeriphery не запущено');
    }
  }
}
